import { createDamageStore } from '@declaration/store/createDamageStore';
import { Step } from '@shared/claim/steps';
import { emptyUploadedFileCollection } from '@shared/files/uploadedFiles';
import equipmentConstraints from '@shared/validator/constraints/equipmentConstraints';
import { newClientIdentifier } from '@shared/utils/clientIdentifier';
export const name = 'equipment';
export const namespaced = true;
function newEquipment() {
    return {
        id: null,
        clientIdentifier: newClientIdentifier(),
        name: null,
        brandOrModel: null,
        age: null,
        purchasePrice: null,
        receipt: emptyUploadedFileCollection(),
        pictureCollection: emptyUploadedFileCollection(),
    };
}
const { createDamageState, damageGetters, damageActions, damageMutations } = createDamageStore(newEquipment, equipmentConstraints, Step.EquipmentsDetails, 'equipments');
export const state = createDamageState;
export const getters = {
    ...damageGetters,
    getEquipmentDamagePositionSuffix: (state) => (slug, index) => {
        if (!slug) {
            return null;
        }
        let positionWithSameCategory = 1;
        let isTheOnlyOneWithCategory = true;
        state.damages.forEach((damage, otherIndex) => {
            if (damage.name === slug && otherIndex !== index) {
                isTheOnlyOneWithCategory = false;
                if (otherIndex < index) {
                    positionWithSameCategory += 1;
                }
            }
        });
        return isTheOnlyOneWithCategory ? null : positionWithSameCategory.toString();
    },
};
export const actions = {
    ...damageActions,
    async validateEquipmentsStep({ dispatch, rootState, commit }) {
        // ensure Step.EquipmentsDetails is in StepStack
        if (!rootState.claim.claim.stepStack.includes(Step.EquipmentsDetails)) {
            try {
                await dispatch('claim/saveStepWithoutStoreUpdate', Step.EquipmentsDetails, {
                    root: true,
                });
            }
            catch (_a) {
                dispatch('error/add', 'Une erreur est survenue, merci de réessayer.', { root: true });
                return;
            }
        }
        await dispatch('claim/updateAndSaveClaimStep', Step.Equipments, { root: true });
        commit('RESET_CHANGES');
    },
};
export const mutations = {
    ...damageMutations,
    RESET_STATE(stateObject) {
        Object.assign(stateObject, state());
    },
};
